import { IconBase, IconBaseProps } from 'react-icons';

const humidityIcon = {
    id: 'humidity-icon',
    outlinePath:
        'm 64.3,16 c -3.06,-0.04 -6.18,0.73 -8.97,2.36 h -0 c -1.93,1.12 -3.6,2.63 -4.91,4.43 l -0,0 -22.37,30.94 -0.08,0.13 c -10.49,16.36 -6.3,37.49 9.36,49.29 15.56,11.73 37.75,11.73 53.3,-0 15.66,-11.81 19.87,-32.91 9.49,-49.1 l -0.08,-0.13 -22.48,-31.12 -0,-0.01 c -3.17,-4.39 -8.14,-6.73 -13.25,-6.8 z m -1.34,11.14 c 2.2,-0.31 4.55,0.52 5.68,2.09 l 0,0 22.25,30.81 c 7.36,11.53 4.64,25.65 -6.88,34.34 h -0 c -11.47,8.65 -28.6,8.65 -40.07,0 C 32.42,85.69 29.68,71.61 37.19,59.85 L 59.31,29.24 c 0.39,-0.53 0.91,-1.01 1.55,-1.39 0.65,-0.38 1.36,-0.61 2.09,-0.71 z',
    fillPath:
        'M 64,21.44 92.77,51.53 100.72,75 90.91,96.21 65.72,106.29 38.14,95.28 27.4,79.11 32.57,55.38 48.88,35.62 Z',
};

interface HumidityIconProps {
    humidity?: number;
}

export function HumidityIcon({ humidity, ...props }: IconBaseProps & HumidityIconProps) {
    const { id, fillPath, outlinePath } = humidityIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="HumidityIcon">
            {humidity == null ? (
                <path d={outlinePath} fill="currentColor" />
            ) : (
                <>
                    <defs>
                        <clipPath id="humidity-level">
                            <rect
                                x={0}
                                y={28 + (72 - (humidity * 72) / 100)}
                                width={128}
                                height={72}
                            />
                        </clipPath>
                    </defs>
                    <path d={fillPath} fill="currentColor" clipPath="url(#humidity-level)" />
                </>
            )}
            <path d={outlinePath} fill="currentColor" />
        </IconBase>
    );
}
